import { PatientInfoState, Action } from './types'
import { getDefaultPatientInfo } from './AppStateDefaults'

export const setPatientInfo = (
    {
        patientId = '',
        patientAge = null,
        patientWeight = null,
        patientWeightUnit = 'lbs',
        patientSex = '',
        patientProfile = getDefaultPatientInfo().patientProfile,
        patientProfileExplanation = '',
        hygiene = '',
        boneQuality = '',
        boneQualityExplanation = '',
        utn = '',
        fdi = '',
        didDeviceContributeToInjury = '',
        currentPatientStatus = '',
        typeOfInjury = '',
        typeOfInjuryExplanation = '',
    } = {} as PatientInfoState
) => ({
    type: 'SET_PATIENT_INFO',
    payload: {
        patientId,
        patientAge,
        patientWeight,
        patientWeightUnit,
        patientSex,
        patientProfile,
        patientProfileExplanation,
        hygiene,
        boneQuality,
        boneQualityExplanation,
        utn,
        fdi,
        didDeviceContributeToInjury,
        currentPatientStatus,
        typeOfInjury,
        typeOfInjuryExplanation,
    },
})

const patientInfoReducer: React.Reducer<PatientInfoState, Action> = (
    state: PatientInfoState,
    action: Action
) => {
    switch (action.type) {
        case 'SET_PATIENT_INFO':
            return {
                ...action.payload,
            }
        default:
            return state
    }
}

export default patientInfoReducer
